/** Must match supabase/functions/_shared/kbEmbed.ts KB_SEARCH_DEFAULTS */
export const KB_SEARCH_DEFAULTS = {
  hybrid_enabled: true,
  rag_agents_enabled: false,
  enable_personal_knowledge: false,
  similarity_threshold: 0.5,
  keyword_weight: 1,
  rrf_k: 60,
  default_match_count: 8,
  rerank_enabled: false,
  rerank_candidate_count: 20,
  rerank_top_n: 10,
  vector_index_mode: 'ivfflat',
}

export const KB_VECTOR_INDEX_MODES = ['ivfflat', 'hnsw']

export const KB_PIPELINE_SELECT =
  'hybrid_enabled, rag_agents_enabled, enable_personal_knowledge, similarity_threshold, keyword_weight, rrf_k, default_match_count, rerank_enabled, rerank_candidate_count, rerank_top_n, vector_index_mode'

export const KB_AGENT_BEHAVIOR_SELECT =
  'agent_chat_enabled, agent_max_turns_per_hour, agent_max_tool_iterations, agent_max_history_turns, agent_tool_result_max_chars'

export const KB_AGENT_BEHAVIOR_DEFAULTS = {
  agent_chat_enabled: true,
  agent_max_turns_per_hour: 30,
  agent_max_tool_iterations: 8,
  agent_max_history_turns: 20,
  agent_tool_result_max_chars: 40000,
}

function clampInt(value, fallback, min, max) {
  const n = Number(value)
  if (!Number.isFinite(n)) return fallback
  return Math.min(max, Math.max(min, Math.floor(n)))
}

export function normalizeKbAgentBehavior(row) {
  const base = row || {}
  return {
    agent_chat_enabled: base.agent_chat_enabled !== false,
    agent_max_turns_per_hour: clampInt(base.agent_max_turns_per_hour, 30, 1, 500),
    agent_max_tool_iterations: clampInt(base.agent_max_tool_iterations, 8, 1, 50),
    agent_max_history_turns: clampInt(base.agent_max_history_turns, 20, 1, 200),
    agent_tool_result_max_chars: clampInt(base.agent_tool_result_max_chars, 40000, 1000, 100000),
  }
}
